import {MapListPipe} from '@feature/common';
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {GridsterModule} from "angular-gridster2";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxAngularQueryBuilderModule} from "ngx-angular-query-builder";
import * as common from "@common/index"; /** should be common module */
import * as overview from "@feature/overview/index"; /** should be overview module */
import {DynamicFormsModule} from '@feature/_app_modules/dynamic-forms/dynamic-forms.module';
import * as previewMode from "@feature/preview-mode/index";
import * as creditorAccounts from "@creditor-accounts/index";
import * as invoiceUpload from "@feature/invoice-upload/index";
import * as paymentsToYou from "@feature/payments-to-you/index";
import * as details from "@details/index";
import * as cashBalances from "@cash-balances/index";
import * as property from "@feature/properties/index";
import * as diary from "@diary/index";
import * as auth from "@auth/index";
import * as users from "@feature/users/index";
import * as admin from "@admin/index";
import * as contactUs from "@contact-us/index";
import * as dashboardDesigner from "@dashboard-designer/index";
import * as userProfiles from "@feature/user-profiles/index";
import * as myActivities from "@feature/my-activities/index";
import * as widgetGallery from "@feature/widget-gallery/index";
import {TruncateModule} from '@yellowspot/ng-truncate';
import {MojoWidgetComponent} from "@widget/component/mojo-widget/mojo-widget.component";
import {NavbarComponent} from "@feature/navbar/navbar.component";
import {MultiSelectModule} from "primeng/multiselect";
import {PaginatorModule} from "primeng/paginator";
import {TabViewModule} from "primeng/tabview";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {CheckboxModule} from "primeng/checkbox";
import {DropdownModule} from "primeng/dropdown";
import {ChartModule} from "primeng/chart";
import {SelectButtonModule} from "primeng/selectbutton";
import {InputTextModule} from "primeng/inputtext";
import {FileUploadModule} from "primeng/fileupload";
import {GalleriaModule} from "primeng/galleria";
import {CalendarModule} from "primeng/calendar";
import {ContextMenuModule} from "primeng/contextmenu";
import {MenuModule} from "primeng/menu";
import {SidebarModule} from "primeng/sidebar";
import {ToolbarModule} from "primeng/toolbar";
import {PasswordModule} from "primeng/password";
import {AccordionModule} from "primeng/accordion";
import {TooltipModule} from "primeng/tooltip";
import {ListboxModule} from "primeng/listbox";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {InputSwitchModule} from "primeng/inputswitch";
import {InputMaskModule} from "primeng/inputmask";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {AutoCompleteModule} from "primeng/autocomplete";
import {ConfirmationService} from "primeng/api";
import {FieldsetModule} from "primeng/fieldset";
import {RadioButtonModule} from "primeng/radiobutton";
import {AboutComponent, AboutPageComponent} from "@about/index";
import {PropertyPictureComponent} from "@properties/containers/property-picture/property-picture.component";
import {BrandCssLoaderComponent} from "@brand/index";
import {TenancyScheduleComponent} from "@feature/tenancy-schedule/containers/tenancy-schedule.component";
import {CalendarNavigatorComponent} from "@diary/components/calendar-navigator/calendar-navigator.component";
import {
  CalendarDuodecennialViewComponent
} from "@diary/components/calendar-duodecennial-view/calendar-duodecennial-view.component";
import {CalendarYearViewComponent} from "@diary/components/calendar-year-view/calendar-year-view.component";
import {CalendarMonthViewComponent} from "@diary/components/calendar-month-view/calendar-month-view.component";
import {CalendarDayViewComponent} from "@diary/components/calendar-day-view/calendar-day-view.component";
import {DiaryEventDetailsComponent} from "@diary/components/diary-event-details/diary-event-details.component";
import {FilterButtonComponent} from "@widget/component/filter-button/filter-button.component";
import {ManagerDetailsComponent} from "@feature/manager-details";
import {CreditorDetailsModule} from "@feature/creditor-details/creditor-details.module";
import {WidgetColumnsModule} from "@feature/widget-columns/widget-columns.module";
import {
  PmaDocumentCentreCategoryEditorComponent
} from "@feature/pma-document-centre/containers/pma-document-centre-category-editor/pma-document-centre-category-editor.component";
import {
  PmaDocumentCentreCategoryDialogComponent
} from "@feature/pma-document-centre/components/pma-document-centre-category-dialog/pma-document-centre-category-dialog.component";
import {TableModule as CarlsTableModule} from "./table/table.module";
import {DbwLayoutModule} from "@feature/_app_modules/dbw-layout/dbw-layout.module";
import {
  AdditionalInformationAdminModule,
} from "@feature/_app_modules/additional-information/additional-information-admin.module";
import {CreditorDetailsWidgetComponent} from "@feature/creditor-details/components/creditor-details-widget.component";
import {SupportPageComponent} from "../mojo/mojo-admin-dashboard/container/support-page/support-page.component";
import {TableModule} from 'primeng/table';
import {TreeTableModule} from 'primeng/treetable';
import {WidgetTableComponent} from './table/widget-table-component/widget-table.component';
import {MojoNgxAngularQueryBuilderModule} from '../query-builder/query-builder.module';
import {
  ListerConfigurationComponent
} from '@admin/containers/system-configuration-page/sections/lister-configuration/lister-configuration.component';
import {
  MiddleOfPageDottedSpinnerComponent
} from '@common/list-widget-table/components/middle-of-page-dotted-spinner/middle-of-page-dotted-spinner.component';
import {DesktopContactUsModule} from '../contact-us/desktop-contact-us/desktop-contact-us.module';
import {ChipsModule} from 'primeng/chips';
import {OrderListModule} from 'primeng/orderlist';
import {UserPreferencesHttpService} from '@feature/user-preferences/services/user-preferences-http.service';
import {UserPreferencesService} from '@feature/user-preferences/services/user-preferences.service';
import {UserPreferencesComponent} from '@feature/user-preferences/components/user-preferences.component';
import {
  PeriodicEmailSettingsComponent
} from '@feature/user-preferences/components/periodic-email-settings/periodic-email-settings.component';
import {HoursMinutesComponent} from '@feature/user-preferences/components/hours-minutes/hours-minutes.component';
import {PrintingModule} from '../printing/printing.module';
import {ExportCsvService} from './export-csv/services/export-csv-data.service';
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import { TenancySchedulePrintLayoutComponent } from '@feature/tenancy-schedule/components/tenancy-schedule-print-layout.component';
import {HeadLeaseScheduleWidgetComponent} from "@head-lease-schedule/containers/head-lease-schedule-widget.component";
import {HeadLeaseSchedulePrintLayoutComponent} from "@head-lease-schedule/components/head-lease-schedule-print-layout.component";

@NgModule({
  imports: [
    // primeng
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ConfirmDialogModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    GalleriaModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    ListboxModule,
    MenuModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    PaginatorModule,
    PasswordModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    SidebarModule,
    TabViewModule,
    TableModule,
    TreeTableModule,
    ToolbarModule,
    TooltipModule,
    FieldsetModule,
    RadioButtonModule,
    // end primeng
    TruncateModule,
    common.CountToModule,
    common.HideDropdownOnScrollModule,
    common.NumericInputDirectiveModule,
    AdditionalInformationAdminModule,
    DbwLayoutModule,
    WidgetColumnsModule,
    GridsterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxAngularQueryBuilderModule,
    CreditorDetailsModule,
    CarlsTableModule,
    DynamicFormsModule,
    DesktopContactUsModule,
    OrderListModule,
    MojoNgxAngularQueryBuilderModule,
    PrintingModule,
    NgxExtendedPdfViewerModule
  ],
  declarations: [
    MojoWidgetComponent,
    previewMode.PreviewModeExitComponent,
    previewMode.ProductPreviewComponent,
    previewMode.MciPreviewModeDialogComponent,
    previewMode.MciPreviewModeDialogContainerComponent,
    previewMode.MfsPreviewModeDialogContainerComponent,
    previewMode.MfsPreviewModeDialogComponent,
    previewMode.MftPreviewModeDialogContainerComponent,
    previewMode.MftPreviewModeDialogComponent,
    CreditorDetailsWidgetComponent,
    common.TwitterComponent,
    common.ViewbarComponent,
    common.ContactComponent,
    common.FileUploadComponent,
    common.TablePaginatorComponent,
    common.ListerPageTitleComponent,
    common.PageTitleComponent,
    common.TestchartComponent,
    common.TwitterTimelineComponent,
    common.PictureComponent,
    common.ConfirmationDialogBoxComponent,
    common.FilterEditorDialogComponent,
    common.TileBarComponent,
    common.TileBarItemComponent,
    common.ListWidgetTableComponent,
    overview.OverviewComponent,
    overview.OverviewItemComponent,
    overview.AdminOverviewComponent,
    overview.OverviewItemsContainerComponent,
    PmaDocumentCentreCategoryDialogComponent,
    PmaDocumentCentreCategoryEditorComponent,
    FilterButtonComponent,
    details.DetailItemsBodyComponent,
    details.DetailsWidgetComponent,
    ManagerDetailsComponent,
    PropertyPictureComponent,
    BrandCssLoaderComponent,
    widgetGallery.WidgetGalleryComponent,
    cashBalances.CashBalanceWidgetComponent,
    cashBalances.CashBalanceTableComponent,
    cashBalances.CashBalanceChartComponent,
    property.PropertyMapWidget,
    property.PropertyGalleryComponent,
    diary.DiaryWidgetComponent,
    diary.CalendarComponent,
    diary.DiaryEventComponent,
    diary.DiaryEventsComponent,
    diary.CalendarDayViewComponent,
    diary.CalendarDuodecennialViewComponent,
    diary.CalendarMonthViewComponent,
    diary.CalendarYearViewComponent,
    diary.CalendarNavigatorComponent,
    auth.ErrorPageComponent,
    auth.SigninCallbackComponent,
    users.UsersPageComponent,
    users.UserTableComponent,
    users.UserWidgetComponent,
    users.NewUserPageComponent,
    users.UserEditorComponent,
    admin.SystemConfigurationPageComponent,
    ListerConfigurationComponent,
    admin.WidgetAdminPageComponent,
    admin.WidgetTableComponent,
    admin.ProfileAndDashboardConfigPageComponent,
    admin.ProfileTableComponent,
    admin.ProfileEditorComponent,
    admin.ClientAdminPageComponent,
    admin.ClientParentAdminPageComponent,
    admin.ClientProfileTableComponent,
    admin.ClientEditorComponent,
    admin.ClientParentEditorComponent,
    admin.MciPreviewModeTileComponent,
    admin.MasterAdminMciWidgetComponent,
    admin.MasterAdminMojoWidgetComponent,
    admin.NavigatorPanelComponent,
    admin.MasterAdminIdsWidgetComponent,
    admin.EmailTemplatesPageComponent,
    admin.EmailTemplatesTableComponent,
    admin.EmailTemplateEditorComponent,
    admin.MasterAdminMfsWidgetComponent,
    admin.MasterAdminMftWidgetComponent,
    admin.SupplierOtherCreditorAdminPageComponent,
    admin.SupplierOtherCreditorProfileTableComponent,
    admin.SupplierOtherCreditorEditorComponent,
    admin.MojoSystemSettingsComponent,
    admin.ActivitySettingsComponent,
    admin.GeneralInformationComponent,
    admin.OverviewConfigurationComponent,
    admin.ApprovalGroupComponent,
    admin.SuggestedCodingComponent,
    admin.FaqCategoriesComponent,
    admin.DocumentCentreSettingsComponent,
    admin.ContactUsSubjectsComponent,
    admin.SubjectDialogComponent,
    admin.FaqCategoryDialogComponent,
    admin.MojoListerConfigurationComponent,
    admin.MojoSendTestEmailComponent,
    admin.MojoMsOAuthSettingsViewerComponent,
    admin.MojoSmtpSettingsViewerComponent,
    SupportPageComponent,
    TenancyScheduleComponent,
    TenancySchedulePrintLayoutComponent,
    HeadLeaseSchedulePrintLayoutComponent,
    contactUs.ContactUsWidgetComponent,
    contactUs.ContactUsContainerComponent,
    dashboardDesigner.ProfileSelectorComponent,
    dashboardDesigner.DashboardSelectorComponent,
    dashboardDesigner.DesignerWidgetComponent,
    myActivities.MyActivitiesComponent,
    myActivities.ActivityTableComponent,
    userProfiles.UsersProfilesPageComponent,
    userProfiles.UserProfileTableComponent,
    CalendarNavigatorComponent,
    CalendarDuodecennialViewComponent,
    CalendarYearViewComponent,
    CalendarMonthViewComponent,
    CalendarDayViewComponent,
    DiaryEventDetailsComponent,
    AboutComponent,
    AboutPageComponent,
    NavbarComponent,
    creditorAccounts.CreditorAccountsBodyComponent,
    creditorAccounts.CreditorAccountsWidgetMojoPmaComponent,
    creditorAccounts.CreditorAccountsWidgetMfsComponent,
    invoiceUpload.InvoiceUploadWidgetComponent,
    invoiceUpload.InvoiceUploadItemComponent,
    invoiceUpload.InvoiceUploadComponent,
    invoiceUpload.InvoiceInputDialogComponent,
    invoiceUpload.InputFieldComponent,
    invoiceUpload.AdditionalDocsComponent,
    invoiceUpload.AdditionalDocItemComponent,
    paymentsToYou.PaymentsToYouWidgetComponent,
    paymentsToYou.RemittanceDocumentPrintLayoutComponent,
    common.FileSizePipe,
    common.FloorPipe,
    common.SecureImagePipe,
    common.SortCodePipe,
    common.IBANExportPipe,
    common.IBANDisplayPipe,
    MapListPipe,
    WidgetTableComponent,
    MiddleOfPageDottedSpinnerComponent,
    UserPreferencesComponent,
    PeriodicEmailSettingsComponent,
    HoursMinutesComponent,
    HeadLeaseScheduleWidgetComponent,
  ],
  exports: [
    common.FileSizePipe,
    common.FloorPipe,
    common.SecureImagePipe,
    common.SortCodePipe,
    MapListPipe,
    // primeng
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ConfirmDialogModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    GalleriaModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    ListboxModule,
    MenuModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    PaginatorModule,
    PasswordModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    SidebarModule,
    TabViewModule,
    TableModule,
    TreeTableModule,
    ToolbarModule,
    TooltipModule,
    FieldsetModule,
    RadioButtonModule,
    // end primeng
    TruncateModule,
    DesktopContactUsModule,
    AdditionalInformationAdminModule,
    DbwLayoutModule,
    WidgetColumnsModule,
    NgxAngularQueryBuilderModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CreditorDetailsModule,
    PrintingModule,
    FilterButtonComponent,
    MojoWidgetComponent,
    previewMode.PreviewModeExitComponent,
    previewMode.ProductPreviewComponent,
    previewMode.MciPreviewModeDialogComponent,
    previewMode.MciPreviewModeDialogContainerComponent,
    previewMode.MfsPreviewModeDialogContainerComponent,
    previewMode.MfsPreviewModeDialogComponent,
    previewMode.MftPreviewModeDialogContainerComponent,
    previewMode.MftPreviewModeDialogComponent,
    CreditorDetailsWidgetComponent,
    common.TwitterComponent,
    common.ViewbarComponent,
    common.ContactComponent,
    common.FileUploadComponent,
    common.TablePaginatorComponent,
    common.ListerPageTitleComponent,
    common.PageTitleComponent,
    common.TestchartComponent,
    common.TwitterTimelineComponent,
    common.PictureComponent,
    common.ConfirmationDialogBoxComponent,
    common.FilterEditorDialogComponent,
    common.TileBarComponent,
    common.TileBarItemComponent,
    common.ListWidgetTableComponent,
    overview.OverviewComponent,
    overview.OverviewItemComponent,
    overview.AdminOverviewComponent,
    overview.OverviewItemsContainerComponent,
    PmaDocumentCentreCategoryDialogComponent,
    PmaDocumentCentreCategoryEditorComponent,
    FilterButtonComponent,
    details.DetailItemsBodyComponent,
    details.DetailsWidgetComponent,
    ManagerDetailsComponent,
    PropertyPictureComponent,
    BrandCssLoaderComponent,
    widgetGallery.WidgetGalleryComponent,
    cashBalances.CashBalanceWidgetComponent,
    cashBalances.CashBalanceTableComponent,
    cashBalances.CashBalanceChartComponent,
    property.PropertyMapWidget,
    property.PropertyGalleryComponent,
    diary.DiaryWidgetComponent,
    diary.CalendarComponent,
    diary.DiaryEventComponent,
    diary.DiaryEventsComponent,
    diary.CalendarDayViewComponent,
    diary.CalendarDuodecennialViewComponent,
    diary.CalendarMonthViewComponent,
    diary.CalendarYearViewComponent,
    diary.CalendarNavigatorComponent,
    auth.ErrorPageComponent,
    auth.SigninCallbackComponent,
    users.UsersPageComponent,
    users.UserTableComponent,
    users.UserWidgetComponent,
    users.NewUserPageComponent,
    users.UserEditorComponent,
    admin.SystemConfigurationPageComponent,
    admin.WidgetAdminPageComponent,
    admin.WidgetTableComponent,
    admin.ProfileAndDashboardConfigPageComponent,
    admin.ProfileTableComponent,
    admin.ProfileEditorComponent,
    admin.ClientAdminPageComponent,
    admin.ClientParentAdminPageComponent,
    admin.ClientProfileTableComponent,
    admin.ClientEditorComponent,
    admin.ClientParentEditorComponent,
    admin.MciPreviewModeTileComponent,
    admin.MasterAdminMciWidgetComponent,
    admin.MasterAdminMojoWidgetComponent,
    admin.NavigatorPanelComponent,
    admin.MasterAdminIdsWidgetComponent,
    admin.EmailTemplatesPageComponent,
    admin.EmailTemplatesTableComponent,
    admin.EmailTemplateEditorComponent,
    admin.MasterAdminMfsWidgetComponent,
    admin.MasterAdminMftWidgetComponent,
    admin.SupplierOtherCreditorAdminPageComponent,
    admin.SupplierOtherCreditorProfileTableComponent,
    admin.SupplierOtherCreditorEditorComponent,
    admin.MojoSystemSettingsComponent,
    admin.ActivitySettingsComponent,
    admin.GeneralInformationComponent,
    admin.OverviewConfigurationComponent,
    admin.ApprovalGroupComponent,
    admin.SuggestedCodingComponent,
    admin.FaqCategoriesComponent,
    admin.DocumentCentreSettingsComponent,
    admin.MojoListerConfigurationComponent,
    SupportPageComponent,
    TenancyScheduleComponent,
    TenancySchedulePrintLayoutComponent,
    HeadLeaseSchedulePrintLayoutComponent,
    contactUs.ContactUsWidgetComponent,
    contactUs.ContactUsContainerComponent,
    dashboardDesigner.ProfileSelectorComponent,
    dashboardDesigner.DashboardSelectorComponent,
    dashboardDesigner.DesignerWidgetComponent,
    myActivities.MyActivitiesComponent,
    myActivities.ActivityTableComponent,
    userProfiles.UsersProfilesPageComponent,
    userProfiles.UserProfileTableComponent,
    CalendarNavigatorComponent,
    CalendarDuodecennialViewComponent,
    CalendarYearViewComponent,
    CalendarMonthViewComponent,
    CalendarDayViewComponent,
    DiaryEventDetailsComponent,
    AboutComponent,
    NavbarComponent,
    creditorAccounts.CreditorAccountsBodyComponent,
    creditorAccounts.CreditorAccountsWidgetMojoPmaComponent,
    creditorAccounts.CreditorAccountsWidgetMfsComponent,
    invoiceUpload.InvoiceUploadWidgetComponent,
    invoiceUpload.InvoiceUploadItemComponent,
    invoiceUpload.InvoiceUploadComponent,
    invoiceUpload.InvoiceInputDialogComponent,
    invoiceUpload.InputFieldComponent,
    invoiceUpload.AdditionalDocsComponent,
    invoiceUpload.AdditionalDocItemComponent,
    paymentsToYou.PaymentsToYouWidgetComponent,
    paymentsToYou.RemittanceDocumentPrintLayoutComponent,
    WidgetTableComponent,
    MiddleOfPageDottedSpinnerComponent,
    HeadLeaseScheduleWidgetComponent,
  ],
  providers: [
    ConfirmationService,
    common.FileSizePipe,
    common.FloorPipe,
    common.SecureImagePipe,
    common.SortCodePipe,
    common.IBANExportPipe,
    common.IBANDisplayPipe,
    UserPreferencesService,
    UserPreferencesHttpService,
    ExportCsvService
  ],
})
export class SharedModule {
}
